


















































































































































import "@/assets/ZohoEmbededAppSDK.min.js";
import { Component, Vue } from "vue-property-decorator";
import Home from "@/views/Home.vue";
import Projects from "@/views/Projects.vue";
import MyTimelog from "@/views/MyTimelog.vue";
import Loader from "@/components/misc/Loader.vue";

import { mapGetters } from "vuex";

@Component({
  components: { Home, Loader, MyTimelog, Projects },
  computed: {
    ...mapGetters({
      alertMessage: "mainStore/alertMessage",
      hasAdminLevel: "authStore/getHasAdminLevel",
      hasSuperAdminLevel: "authStore/getHasSuperAdminLevel",
      isAuthenticated: "authStore/isTokenActive",
      isLoading: "mainStore/isLoading",
      userProfile: "authStore/getUserProfile",
    }),
  },
})
export default class App extends Vue {
  sidebarCollapse = false;
  timesheetsCollapsed = false;
  ticketsCollapsed = false;
  adminCollapsed = false;
  reportCollapsed = false;

  // HACK
  hasAdminLevel!: boolean;
  isAuthenticated!: boolean;
  hasSuperAdminLevel!: boolean;
  isLoading!: boolean;

  get alertMessageText() {
    return this.$store.getters["mainStore/alertMessage"]?.text;
  }

  get isErrorAlert() {
    return this.$store.getters["mainStore/alertMessage"]?.type == "error";
  }

  get isInfoAlert() {
    return this.$store.getters["mainStore/alertMessage"]?.type == "info";
  }

  get isSuccessAlert() {
    return this.$store.getters["mainStore/alertMessage"]?.type == "success";
  }

  toogleAdminCollapse() {
    this.adminCollapsed = !this.adminCollapsed;
    if (this.adminCollapsed) {
      this.timesheetsCollapsed = false;
      this.ticketsCollapsed = false;
      this.reportCollapsed = false;
    }
  }

  toogleTimesheetsCollapse() {
    this.timesheetsCollapsed = !this.timesheetsCollapsed;
    if (this.timesheetsCollapsed) {
      this.ticketsCollapsed = false;
      this.adminCollapsed = false;
      this.reportCollapsed = false;
    }
  }
  toogleTicketsCollapse() {
    this.ticketsCollapsed = !this.ticketsCollapsed;
    if (this.ticketsCollapsed) {
      this.timesheetsCollapsed = false;
      this.adminCollapsed = false;
      this.reportCollapsed = false;
    }
  }
  toggleReportsCollapse() {
    this.reportCollapsed = !this.reportCollapsed;
    if (this.reportCollapsed) {
      this.ticketsCollapsed = false;
      this.timesheetsCollapsed = false;
      this.adminCollapsed = false;
    }
  }
}
